import { clearListingAssetCache } from './listingAssetCache.js'

/** Persist the credentials returned by login or immediate registration. */
export function saveAuthData({ access, refresh, user }) {
  localStorage.setItem('access_token', access)
  localStorage.setItem('refresh_token', refresh)
  localStorage.setItem('user', JSON.stringify(user))
}

export function clearAuthData() {
  void clearListingAssetCache()
  for (const key of ['access_token', 'refresh_token', 'user', 'user_session_active']) {
    localStorage.removeItem(key)
  }
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user'))
  } catch {
    return null
  }
}
